module.exports = __webpack_public_path__ + "img/svg/header-separator.d49556b2f218a924a5053a390de71d68.svg";